import { useState, useEffect, useLayoutEffect } from 'react';
import { useFormContext } from '../../../contexts/form';

const idInList = ({ optionsList, itemId }) => (
  (id) => optionsList.map((item) => item[itemId]).includes(id)
);

const useAutocomplete = (
  name,
  value,
  options,
  itemId,
  onChangeAutocomplete,
  multiple,
  freeSolo,
  itemLabel,
) => {
  const { formSetValue } = useFormContext();
  const [inputValue, setInputValue] = useState(multiple ? [] : null);
  const [optionsList, setOptionsList] = useState([]);

  useLayoutEffect(() => {
    let input = multiple ? [] : null;
    let changed = false;
    let valuesList = value;
    if (multiple) {
      if (typeof (value) === 'string') {
        valuesList = [value];
      }

      valuesList = valuesList.filter(idInList({ optionsList, itemId }));

      if (valuesList.length > 0 && optionsList.length > 0) {
        valuesList.forEach((el) => {
          const selected = optionsList.find((element) => element[itemId] === el);
          if (selected) {
            input = [...input, selected];
            changed = true;
          }
        });
      }
    } else if (value && value.toString() !== '' && optionsList.length > 0) {
      const selected = optionsList.find((element) => element[itemId] === value);
      if (selected) {
        input = selected;
        changed = true;
      }
    }

    if (changed) {
      if (multiple) {
        formSetValue(name, valuesList);
        formSetValue(`${name}_aux`, input);
      } else if (input) {
        formSetValue(name, input[itemId] || '');
        formSetValue(`${name}_aux`, input[itemLabel] || '');
      } else {
        formSetValue(name, '');
        formSetValue(`${name}_aux`, '');
      }
    }
    setInputValue(input);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, optionsList]);

  useEffect(() => {
    if (JSON.stringify(options) !== JSON.stringify(optionsList)) {
      setOptionsList(options);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  const onChange = (registerOnChange) => (event, valueEvent) => {
    if (event.key === 'Enter') event.preventDefault();
    let actualValue = valueEvent ? valueEvent[itemId] : '';

    if (multiple) {
      actualValue = [];
      valueEvent.forEach((element) => {
        actualValue.push(element[itemId]);
      });
    }

    if (freeSolo) {
      actualValue = [];
      valueEvent.forEach((element) => {
        actualValue.push(element[itemId] || element);
      });
    }

    const newEvent = {};
    newEvent.target = {
      name,
      value: actualValue,
      object: valueEvent,
    };

    onChangeAutocomplete(newEvent);
    registerOnChange(newEvent);
  };

  return {
    inputValue,
    onChange,
  };
};

export default useAutocomplete;
